import React, { useEffect, useState } from 'react';
import ModalWrapper from '../../components/elements/ModalWrapper';
import ModalConfirmation from '../../components/fragments/ModalConfirmation';
import FormMission from './FormMission';
import { useMutation } from '@tanstack/react-query';
import { getBusinessUnit } from '../../services/mission';
import { ComboboxData, LoadingOverlay } from '@mantine/core';

interface CreateMissionProps {
  isVisible: boolean;
  loading?: boolean;
  onClose: () => void;
  onSubmit: (data: any) => void;
  data: any;
  type: string;
}

const CreateMission: React.FC<CreateMissionProps> = ({
  isVisible,
  onSubmit,
  onClose,
  loading,
  data,
  type
}) => {
  const [modalDialog, setModalDialog] = useState({
    show: false,
    data: null
  });

  const [listBusinessUnit, setListBusinessUnit] = useState<ComboboxData>([]);
  const fetchedTargetAudience = useMutation({
    mutationFn: () => getBusinessUnit(),
    onSuccess: (response) => {
      if (response?.data?.data && response?.data?.data.length > 0) {
        const modifiedData = response?.data?.data.map((item: any) => {
          return {
            value: item.buCode,
            label: item.buName
          };
        });
        setListBusinessUnit(modifiedData);
      } else {
        setListBusinessUnit([]);
      }
    }
  });

  useEffect(() => {
    fetchedTargetAudience.mutate();
  }, []);

  const handleSubmitData = (data: any) => {
    setModalDialog({
      show: true,
      data: data
    });
  };

  const handleConfirm = () => {
    setModalDialog({
      show: false,
      data: null
    });
    onSubmit(modalDialog.data);
  };

  const renderData = () => {
    if (type === 'edit') {
      return {
        ...data,
        targetAudience: data.targetAudience.map(
          (item: any) => item.value
        )
      };
    }
    return data;
  };

  return (
    <>
      <ModalWrapper
        title={`${type === 'edit' ? 'Update' : 'Create'} Mission`}
        isVisible={isVisible}
        onClose={onClose}
        size={'xl'}
      >
        <FormMission
          onClose={onClose}
          loading={loading}
          handleSubmitData={handleSubmitData}
          type={type}
          data={renderData()}
          listBusinessUnit={listBusinessUnit}
        />

        <LoadingOverlay visible={fetchedTargetAudience.isLoading} h={'100%'} />
      </ModalWrapper>

      <ModalConfirmation
        isVisible={modalDialog.show}
        type={type}
        onCancel={() => {
          setModalDialog({
            show: false,
            data: null
          });
        }}
        onConfirm={handleConfirm}
      />
    </>
  );
};

export default CreateMission;
